import { filter } from 'lodash';
import { Toast } from 'antd-mobile';

export const showModelError = (content, fallback) => {
  Toast.show({ icon: 'fail', content });
  return fallback;
};

export const normalizeDXPReward = item => ({
  ...item,
  orderId: item.orderNbr,
  prcResSn: item.couponSn,
  prcResPwd: item.couponPwd,
  prcResExpDate: item.expDate,
  couponId: item.couponSn,
  telcoFlag: item.isTelco ? 'Y' : 'N',
  participated: item.participatedNum,
  sendMethod: item.physicalRewardClaimMethod,
  isManualReceive: item.isManualReceive ? 'Y' : 'N',
  keyId: item.rewardInstanceId,
  receiveDeadDate: item.deadLine,
});

export const normalizeDXPRewardList = data =>
  filter(data || [], item => item.rewardType !== '11').map(normalizeDXPReward);
